(function () {
  'use strict';

  var $ = function (selector, context) {
    return (context || document).querySelector(selector);
  };
  var $$ = function (selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  };
  var money = function (cents) {
    return '₹' + (Number(cents || 0) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var escapeHtml = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char];
    });
  };
  var imageUrl = function (url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  };

  /* ---------- announcement bar ---------- */
  var announcement = $('.announcement-bar');
  var messages = $$('.announce-msg');
  if (announcement && messages.length > 1) {
    var announcementIndex = 0;
    var announcementInterval = parseInt(announcement.dataset.announcementInterval || '4000', 10);
    window.setInterval(function () {
      messages[announcementIndex].classList.remove('active');
      announcementIndex = (announcementIndex + 1) % messages.length;
      messages[announcementIndex].classList.add('active');
    }, Math.max(2000, announcementInterval));
  }

  /* ---------- responsive mobile navigation ---------- */
  var menuToggle = $('.menu-toggle');
  var mobileMenu = $('.mobile-menu');
  var menuClose = function () {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
  };
  var menuOpen = function () {
    if (!mobileMenu) return;
    mobileMenu.classList.add('active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
    var closeButton = $('.menu-close', mobileMenu);
    if (closeButton) closeButton.focus();
  };
  if (menuToggle) menuToggle.addEventListener('click', menuOpen);
  $$('[data-menu-close]').forEach(function (element) { element.addEventListener('click', menuClose); });

  /* ---------- full-screen search overlay ---------- */
  var searchOverlay = $('[data-search-overlay]');
  var searchTriggers = $$('[data-search-open]');
  var searchCloseButtons = $$('[data-search-close]');
  var searchInput = $('[data-search-input]', searchOverlay || document);
  var searchOpener = null;
  var searchClose = function () {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('active');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchOverlay.hidden = true;
    searchTriggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('no-scroll');
    if (searchOpener && document.contains(searchOpener)) searchOpener.focus();
    searchOpener = null;
  };
  var searchOpen = function (event) {
    if (!searchOverlay) return;
    if (event) event.preventDefault();
    searchOpener = event ? event.currentTarget : null;
    menuClose();
    searchOverlay.hidden = false;
    searchOverlay.classList.add('active');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchTriggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('no-scroll');
    window.requestAnimationFrame(function () { if (searchInput) searchInput.focus(); });
  };
  searchTriggers.forEach(function (trigger) { trigger.addEventListener('click', searchOpen); });
  searchCloseButtons.forEach(function (element) { element.addEventListener('click', searchClose); });

  /* ---------- return / exchange contact method ---------- */
  $$('[data-return-switch]').forEach(function (switcher) {
    var methodButtons = $$('[data-return-method]', switcher);
    var contactField = $('[data-return-contact]', switcher.parentElement);
    if (!contactField) return;
    methodButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var method = button.dataset.returnMethod || 'email';
        methodButtons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        contactField.type = method === 'phone' ? 'tel' : 'email';
        contactField.name = method === 'phone' ? 'contact[phone]' : 'contact[email]';
        contactField.placeholder = method === 'phone' ? 'Enter Phone' : 'Enter Email';
        contactField.setAttribute('autocomplete', method === 'phone' ? 'tel' : 'email');
      });
    });
  });

  /* ---------- countdown timers ---------- */
  $$('[data-countdown-minutes]').forEach(function (element) {
    var minutes = parseInt(element.dataset.countdownMinutes || '120', 10);
    var key = 'audace_timer_' + (element.dataset.timerId || 'default');
    var end = parseInt(localStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      localStorage.setItem(key, String(end));
    }
    var hours = element.querySelector('.t-h');
    var mins = element.querySelector('.t-m');
    var secs = element.querySelector('.t-s');
    var tick = function () {
      var remaining = Math.max(0, end - Date.now());
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      if (hours) hours.textContent = String(h).padStart(2, '0');
      if (mins) mins.textContent = String(m).padStart(2, '0');
      if (secs) secs.textContent = String(s).padStart(2, '0');
      if (!remaining) {
        end = Date.now() + minutes * 60000;
        localStorage.setItem(key, String(end));
      }
    };
    tick();
    window.setInterval(tick, 1000);
  });

  /* ---------- live viewer count ---------- */
  $$('[data-viewers]').forEach(function (element) {
    var range = (element.dataset.viewers || '14-32').split('-').map(Number);
    var min = range[0] || 14;
    var max = range[1] || 32;
    var value = min + Math.floor(Math.random() * Math.max(1, max - min + 1));
    var output = $('.viewer-n', element);
    var update = function () {
      value += Math.random() > 0.5 ? 1 : -1;
      value = Math.max(min, Math.min(max, value));
      if (output) output.textContent = value;
    };
    update();
    window.setInterval(update, 7000 + Math.random() * 5000);
  });

  /* ---------- country-aware checkout choice ---------- */
  var isIndia = ['Asia/Kolkata', 'Asia/Calcutta'].indexOf(Intl.DateTimeFormat().resolvedOptions().timeZone) > -1;
  if (isIndia) document.documentElement.classList.add('india-checkout');

  /* ---------- cart drawer ---------- */
  var drawer = $('.cart-drawer');
  var drawerOverlay = $('.drawer-overlay');
  var drawerPanel = $('.drawer-panel');
  var cartCache = null;

  var updateCartCount = function (count) {
    $$('.cart-count').forEach(function (element) { element.textContent = count; });
    $$('.cart-count-inline').forEach(function (element) { element.textContent = count; });
  };
  var closeDrawer = function () {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  };
  var refreshDrawer = function () {
    if (!drawer) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(renderDrawer)
      .catch(function () {});
  };
  var openDrawer = function (skipRefresh) {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    if (!skipRefresh) refreshDrawer();
    if (drawerPanel) drawerPanel.focus();
  };
  var renderShipbar = function (total) {
    var bar = $('.drawer-shipbar');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold || '0', 10) * 100;
    if (!threshold) return;
    if (total >= threshold) {
      bar.textContent = bar.dataset.unlockedText || 'Unlocked';
      bar.classList.add('unlocked');
      return;
    }
    var remaining = money(threshold - total);
    var percent = Math.min(100, Math.round(total / threshold * 100));
    bar.classList.remove('unlocked');
    bar.innerHTML = '🎁 <b>' + remaining + '</b> away from ' + escapeHtml(bar.dataset.rewardText || 'free shipping') +
      '<span class="shipbar-track"><span class="shipbar-fill" style="width:' + percent + '%"></span></span>';
  };
  function renderDrawer(cart) {
    cartCache = cart;
    updateCartCount(cart.item_count);
    var body = $('.drawer-items');
    var footer = $('.drawer-footer');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer-empty">Your cart is empty.</p>';
      if (footer) footer.style.display = 'none';
      renderShipbar(0);
      return;
    }
    if (footer) footer.style.display = '';
    body.innerHTML = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="di-variant">' + escapeHtml(item.variant_title) + '</span>' : '';
      return '<div class="drawer-item">' +
        '<img src="' + escapeHtml(imageUrl(item.image)) + '" alt="" width="64" height="84" loading="lazy">' +
        '<div class="drawer-item-info"><span class="di-title">' + escapeHtml(item.product_title) + '</span>' + variant +
        '<div class="di-qty-row"><button class="di-qty" type="button" data-key="' + escapeHtml(item.key) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span>' + item.quantity + '</span><button class="di-qty" type="button" data-key="' + escapeHtml(item.key) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<span class="di-price">' + money(item.final_line_price) + '</span></div>';
    }).join('');
    var subtotal = $('.drawer-subtotal-amount');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    renderShipbar(cart.total_price);
  }
  function changeQuantity(button) {
    button.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: button.dataset.key, quantity: parseInt(button.dataset.q, 10) })
    }).then(function (response) { if (!response.ok) throw new Error('Unable to update cart'); return response.json(); })
      .then(renderDrawer)
      .catch(function () { button.disabled = false; });
  }
  if (drawer) {
    drawer.addEventListener('click', function (event) {
      var quantityButton = event.target.closest('.di-qty');
      if (quantityButton) changeQuantity(quantityButton);
    });
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
    var closeButton = $('.drawer-close');
    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    $$('.cart-icon').forEach(function (element) {
      element.addEventListener('click', function (event) { event.preventDefault(); openDrawer(); });
    });
    refreshDrawer();
  }
  window.audaceOpenDrawer = openDrawer;

  function optimisticAdd(title, price, image, variantTitle) {
    var body = $('.drawer-items');
    var footer = $('.drawer-footer');
    if (!body) return;
    if (footer) footer.style.display = '';
    var previous = cartCache && cartCache.items.length ? body.innerHTML : '';
    body.innerHTML = '<div class="drawer-item optimistic">' +
      '<img src="' + escapeHtml(image) + '" alt="" width="64" height="84">' +
      '<div class="drawer-item-info"><span class="di-title">' + escapeHtml(title) + '</span>' +
      (variantTitle ? '<span class="di-variant">' + escapeHtml(variantTitle) + '</span>' : '') +
      '<div class="di-qty-row"><span class="di-adding">Adding…</span></div></div>' +
      '<span class="di-price">' + money(price) + '</span></div>' + previous;
    var total = (cartCache ? cartCache.total_price : 0) + price;
    var subtotal = $('.drawer-subtotal-amount');
    if (subtotal) subtotal.textContent = money(total);
    updateCartCount((cartCache ? cartCache.item_count : 0) + 1);
    renderShipbar(total);
    openDrawer(true);
  }

  function addSelectedAddons(form) {
    var addons = $$('[data-addon-variant-id]:checked', form).map(function (input) {
      return { id: parseInt(input.dataset.addonVariantId, 10), quantity: 1 };
    }).filter(function (item) { return item.id; });
    if (!addons.length) return Promise.resolve();
    return Promise.all(addons.map(function (item) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(item)
      });
    })).then(function () {});
  }

  var productForm = $('form[data-ajax-cart]');
  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter.name === 'checkout') return;
      event.preventDefault();
      var submitter = event.submitter || $('.btn-buy', productForm);
      var buttonLabel = submitter ? submitter.textContent : '';
      var variant = productForm.querySelector('input[name="id"]:checked') || productForm.querySelector('input[name="id"]');
      var meta = $('.atc-meta', productForm);
      var price = parseInt((variant && variant.dataset.variantPrice) || (meta && meta.dataset.pPrice) || '0', 10);
      var title = (meta && meta.dataset.pTitle) || '';
      var image = (meta && meta.dataset.pImage) || '';
      var variantTitle = (variant && variant.dataset.variantTitle) || '';
      if (submitter) {
        submitter.disabled = true;
        submitter.classList.add('is-added');
        submitter.textContent = '✓ ADDED';
      }
      optimisticAdd(title, price, image, variantTitle);
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Unable to add item'); return response.json(); })
        .then(function () { return addSelectedAddons(productForm); })
        .then(function () { refreshDrawer(); })
        .catch(function () { refreshDrawer(); })
        .finally(function () {
          if (submitter) window.setTimeout(function () {
            submitter.disabled = false;
            submitter.classList.remove('is-added');
            submitter.textContent = buttonLabel;
          }, 2200);
        });
    });
  }

  /* ---------- selected product variant state ---------- */
  function setProductGalleryMedia(mediaIds) {
    var gallery = $('[data-product-gallery]');
    if (!gallery) return;
    var normalizedIds = [];
    (mediaIds || []).forEach(function (mediaId) {
      if (mediaId == null || mediaId === '') return;
      var normalizedId = String(mediaId);
      if (normalizedIds.indexOf(normalizedId) === -1) normalizedIds.push(normalizedId);
    });
    gallery.setAttribute('data-pending-media-ids', normalizedIds.join(','));
    if (typeof gallery.__setVisibleMedia === 'function') gallery.__setVisibleMedia(normalizedIds);
  }

  function syncProductVariant(form, input) {
    if (!input) return;
    var price = parseInt(input.dataset.variantPrice || '0', 10);
    var compare = parseInt(input.dataset.variantCompare || '0', 10);
    var priceOutput = $('[data-current-price]', form.closest('.product-info'));
    var compareOutput = $('[data-compare-price]', form.closest('.product-info'));
    var saveOutput = $('[data-save-badge]', form.closest('.product-info'));
    var meta = $('.atc-meta', form);
    var stickyPrice = $('[data-sticky-price]');
    if (priceOutput) priceOutput.textContent = money(price);
    if (compareOutput) {
      compareOutput.textContent = compare > price ? money(compare) : '';
      compareOutput.style.display = compare > price ? '' : 'none';
    }
    if (saveOutput) {
      saveOutput.textContent = compare > price ? 'SAVE ' + Math.round((compare - price) * 100 / compare) + '%' : '';
      saveOutput.style.display = compare > price ? '' : 'none';
    }
    if (stickyPrice) stickyPrice.textContent = money(price);
    if (meta) {
      meta.dataset.pPrice = price;
      meta.dataset.pImage = input.dataset.variantImageUrl || meta.dataset.defaultImage || meta.dataset.pImage || '';
    }
    if (input.dataset.galleryMediaIds != null) {
      var galleryMediaIds = [];
      try { galleryMediaIds = JSON.parse(input.dataset.galleryMediaIds || '[]'); } catch (error) { galleryMediaIds = []; }
      setProductGalleryMedia(galleryMediaIds);
    }
    if (input.dataset.variantImage) {
      var productGallery = $('[data-product-gallery]');
      var mediaId = String(input.dataset.variantImage).replace(/["\\]/g, '');
      var matchingThumb = productGallery && productGallery.querySelector('.thumb[data-media-id="' + mediaId + '"]');
      if (matchingThumb) matchingThumb.click();
    }
    var buyButton = $('.btn-buy-large', form);
    var checkoutButton = $('.buy-now-button', form);
    if (buyButton) {
      buyButton.disabled = input.dataset.variantAvailable === 'false';
      buyButton.textContent = buyButton.disabled ? 'SOLD OUT' : (buyButton.dataset.defaultText || '+ ADD TO CART');
    }
    if (checkoutButton) checkoutButton.disabled = input.dataset.variantAvailable === 'false';
  }

  $$('[data-buy-now]').forEach(function (button) {
    button.addEventListener('click', function () {
      var addButton = productForm && $('.btn-pulse', productForm);
      if (addButton && !addButton.disabled) addButton.click();
    });
  });
  var variantForm = $('form[data-ajax-cart]');
  if (variantForm) {
    $$('input[name="id"]', variantForm).forEach(function (input) {
      if (input.type === 'hidden') return;
      input.addEventListener('change', function () {
        $$('input[name="id"]', variantForm).forEach(function (other) {
          if (other !== input) other.removeAttribute('checked');
        });
        syncProductVariant(variantForm, input);
      });
    });
  }

  /* ---------- product option matrix: Color swatches + Size buttons ---------- */
  function initProductVariantOptions(form) {
    var variantInput = $('input[name="id"]', form);
    var optionsNode = $('[data-product-options]', form);
    var variantsNode = $('[data-product-variants]', form);
    if (!variantInput || !optionsNode || !variantsNode) return;

    var optionNames;
    var variants;
    try {
      optionNames = JSON.parse(optionsNode.textContent || '[]');
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      return;
    }
    if (!optionNames.length || !variants.length) return;

    var currentVariant = null;
    variants.forEach(function (variant) {
      if (String(variant.id) === String(variantInput.value)) currentVariant = variant;
    });
    currentVariant = currentVariant || variants[0];
    var selectedOptions = (currentVariant.options || []).slice(0, optionNames.length);
    var colorOptionIndex = parseInt(variantInput.dataset.colorOptionIndex || '-1', 10);
    var buttons = $$('[data-option-index][data-option-value]', form);

    var getGalleryMediaIds = function (variant) {
      var mediaIds = [];
      var selectedColor = colorOptionIndex >= 0 ? selectedOptions[colorOptionIndex] : '';
      var addIds = function (candidate) {
        (candidate.gallery_media_ids || []).forEach(function (mediaId) {
          var normalizedId = String(mediaId);
          if (mediaIds.indexOf(normalizedId) === -1) mediaIds.push(normalizedId);
        });
      };
      variants.forEach(function (candidate) {
        var sameColor = colorOptionIndex >= 0 && selectedColor && String(candidate.options[colorOptionIndex] || '') === String(selectedColor);
        if (sameColor || (colorOptionIndex < 0 && String(candidate.id) === String(variant.id))) addIds(candidate);
      });
      if (!mediaIds.length && variant) addIds(variant);
      if (!mediaIds.length && variant && variant.featured_image_id) mediaIds.push(String(variant.featured_image_id));
      return mediaIds;
    };

    var variantMatchesSelection = function (variant) {
      for (var index = 0; index < optionNames.length; index += 1) {
        var selectedValue = selectedOptions[index];
        if (selectedValue && String(variant.options[index] || '') !== String(selectedValue)) return false;
      }
      return true;
    };

    var findMatchingVariant = function (changedIndex) {
      var exactMatch = null;
      var availableMatch = null;
      var firstMatch = null;
      variants.forEach(function (variant) {
        if (variantMatchesSelection(variant)) {
          if (!exactMatch) exactMatch = variant;
          return;
        }
        if (changedIndex < 0 || !selectedOptions[changedIndex] || String(variant.options[changedIndex] || '') !== String(selectedOptions[changedIndex])) return;
        if (!firstMatch) firstMatch = variant;
        if (variant.available && !availableMatch) availableMatch = variant;
      });
      return exactMatch || availableMatch || firstMatch;
    };

    var setVariantInput = function (variant) {
      variantInput.value = variant.id;
      variantInput.dataset.variantTitle = variant.title || '';
      variantInput.dataset.variantPrice = String(variant.price || 0);
      variantInput.dataset.variantCompare = String(variant.compare || 0);
      variantInput.dataset.variantAvailable = variant.available ? 'true' : 'false';
      variantInput.dataset.variantImage = variant.featured_image_id ? String(variant.featured_image_id) : '';
      variantInput.dataset.variantImageUrl = variant.featured_image_url || '';
      variantInput.dataset.galleryMediaIds = JSON.stringify(getGalleryMediaIds(variant));
      for (var index = 0; index < 3; index += 1) {
        variantInput.dataset['option' + (index + 1)] = variant.options[index] || '';
      }
    };

    var updateOptionButtons = function () {
      buttons.forEach(function (button) {
        var optionIndex = parseInt(button.dataset.optionIndex || '-1', 10);
        var optionValue = button.dataset.optionValue || '';
        var candidateOptions = selectedOptions.slice();
        candidateOptions[optionIndex] = optionValue;
        var hasCombination = false;
        var hasAvailableCombination = false;
        var hasOptionValue = false;

        variants.forEach(function (variant) {
          if (String(variant.options[optionIndex] || '') === String(optionValue)) hasOptionValue = true;
          var matches = true;
          for (var index = 0; index < optionNames.length; index += 1) {
            if (candidateOptions[index] && String(variant.options[index] || '') !== String(candidateOptions[index])) {
              matches = false;
              break;
            }
          }
          if (matches) {
            hasCombination = true;
            if (variant.available) hasAvailableCombination = true;
          }
        });

        var isSelected = String(selectedOptions[optionIndex] || '') === String(optionValue);
        var isColorButton = !!button.closest('.product-color-option-group');
        button.disabled = isColorButton ? !hasOptionValue : !hasCombination;
        button.classList.toggle('is-selected', isSelected);
        button.classList.toggle('is-unavailable', hasCombination && !hasAvailableCombination);
        button.classList.toggle('disabled', button.disabled);
        button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
    };

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var optionIndex = parseInt(button.dataset.optionIndex || '-1', 10);
        if (optionIndex < 0) return;
        selectedOptions[optionIndex] = button.dataset.optionValue || '';
        var matchingVariant = findMatchingVariant(optionIndex);
        if (!matchingVariant) return;
        if (!variantMatchesSelection(matchingVariant)) {
          selectedOptions = (matchingVariant.options || []).slice(0, optionNames.length);
        }
        setVariantInput(matchingVariant);
        syncProductVariant(form, variantInput);
        updateOptionButtons();
      });
    });

    setVariantInput(currentVariant);
    syncProductVariant(form, variantInput);
    updateOptionButtons();
  }

  $$('form[data-ajax-cart][data-product-variant-selector]').forEach(initProductVariantOptions);

  /* ---------- bundle offer selector ---------- */
  $$('[data-bundle-offers]').forEach(function (wrapper) {
    var options = $$('.bundle-option', wrapper);
    var total = $('[data-bundle-total]', wrapper);
    var select = function (option) {
      options.forEach(function (item) { item.classList.toggle('selected', item === option); });
      var input = $('input[type="radio"]', option);
      if (input && total && input.dataset.bundleTotal) total.textContent = input.dataset.bundleTotal;
    };
    options.forEach(function (option) {
      var input = $('input[type="radio"]', option);
      if (input) input.addEventListener('change', function () { select(option); });
      option.addEventListener('click', function (event) {
        if (event.target.type !== 'checkbox') {
          var radio = $('input[type="radio"]', option);
          if (radio) { radio.checked = true; select(option); }
        }
      });
      if (input && input.checked) select(option);
    });
  });

  /* ---------- sticky add-to-cart ---------- */
  var sticky = $('[data-sticky-atc]');
  var actions = $('.product-actions');
  if (sticky && actions) {
    var stickyButton = $('.sticky-btn', sticky);
    var stickyCheck = function () {
      sticky.classList.toggle('visible', actions.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', stickyCheck, { passive: true });
    window.addEventListener('resize', stickyCheck, { passive: true });
    stickyCheck();
  }

  /* ---------- product gallery: desktop controls + mobile swipe ---------- */
  $$('[data-product-gallery]').forEach(function (gallery) {
    var track = $('.product-image-track', gallery);
    var images = $$('.product-image-item', gallery);
    var thumbs = $$('.thumb', gallery);
    var counter = $('[data-gallery-counter]', gallery);
    var visibleImages = images.slice();
    var current = 0;
    var mediaIndex = function (list, mediaId) {
      for (var index = 0; index < list.length; index += 1) {
        if (String(list[index].dataset.mediaId || '') === String(mediaId || '')) return index;
      }
      return -1;
    };
    var render = function (index, scroll) {
      if (!visibleImages.length) return;
      current = Math.max(0, Math.min(index, visibleImages.length - 1));
      var activeImage = visibleImages[current];
      var activeMediaId = activeImage && activeImage.dataset.mediaId;
      images.forEach(function (image) {
        image.classList.toggle('is-gallery-hidden', visibleImages.indexOf(image) === -1);
        image.classList.toggle('active', image === activeImage);
      });
      thumbs.forEach(function (thumb) {
        var active = String(thumb.dataset.mediaId || '') === String(activeMediaId || '');
        thumb.classList.toggle('is-gallery-hidden', mediaIndex(visibleImages, thumb.dataset.mediaId) === -1);
        thumb.classList.toggle('active', active);
        thumb.setAttribute('aria-selected', String(active));
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + visibleImages.length;
      if (scroll && track && window.innerWidth < 768) track.scrollTo({ left: current * track.clientWidth, behavior: 'smooth' });
    };
    var setVisibleMedia = function (mediaIds) {
      var previousActiveImage = visibleImages[current] || null;
      var allowed = {};
      (mediaIds || []).forEach(function (mediaId) {
        if (mediaId != null && mediaId !== '') allowed[String(mediaId)] = true;
      });
      var nextImages = images.filter(function (image) { return !!allowed[String(image.dataset.mediaId || '')]; });
      if (!nextImages.length && images.length) nextImages = [images[0]];
      visibleImages = nextImages;
      var nextIndex = previousActiveImage ? visibleImages.indexOf(previousActiveImage) : -1;
      render(nextIndex >= 0 ? nextIndex : 0, true);
    };
    gallery.__setVisibleMedia = setVisibleMedia;
    if (gallery.hasAttribute('data-pending-media-ids')) {
      setVisibleMedia((gallery.getAttribute('data-pending-media-ids') || '').split(',').filter(function (mediaId) { return mediaId !== ''; }));
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var visibleIndex = mediaIndex(visibleImages, thumb.dataset.mediaId);
        if (visibleIndex >= 0) render(visibleIndex, true);
      });
    });
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { render(current - 1, true); });
    if (next) next.addEventListener('click', function () { render(current + 1, true); });
    if (track) track.addEventListener('scroll', function () {
      if (window.innerWidth < 768) render(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), false);
    }, { passive: true });
    var startX = 0;
    if (track) {
      track.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (event) {
        var distance = startX - event.changedTouches[0].clientX;
        if (Math.abs(distance) > 50) render(current + (distance > 0 ? 1 : -1), true);
      }, { passive: true });
    }
    var stage = $('.product-image-stage', gallery);
    if (stage) stage.addEventListener('click', function (event) {
      if (event.target.closest('.gallery-arrow')) return;
      stage.classList.toggle('zoomed');
    });
    var initialVariantInput = variantForm && (variantForm.querySelector('input[name="id"]:checked') || variantForm.querySelector('input[name="id"]'));
    var initialMediaId = initialVariantInput && initialVariantInput.dataset.variantImage;
    var initialIndex = initialMediaId ? mediaIndex(visibleImages, String(initialMediaId).replace(/["\\]/g, '')) : -1;
    render(initialIndex >= 0 ? initialIndex : 0, false);
  });

  /* ---------- home review slider ---------- */
  $$('[data-review-carousel]').forEach(function (carousel) {
    var track = $('[data-review-track]', carousel);
    var slides = $$('.review-slide', carousel);
    var dots = $$('[data-review-dot]', carousel);
    var current = 0;
    var render = function (index) {
      if (!slides.length || !track) return;
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      dots.forEach(function (dot, dotIndex) { dot.classList.toggle('active', dotIndex === current); });
    };
    var prev = $('[data-review-prev]', carousel);
    var next = $('[data-review-next]', carousel);
    if (prev) prev.addEventListener('click', function () { render(current - 1); });
    if (next) next.addEventListener('click', function () { render(current + 1); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { render(parseInt(dot.dataset.reviewDot, 10)); }); });
    render(0);
  });

  /* ---------- customer story video visibility ---------- */
  if ('IntersectionObserver' in window) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) video.play().catch(function () {});
        else video.pause();
      });
    }, { threshold: 0.2 });
    $$('video').forEach(function (video) { video.muted = true; video.playsInline = true; videoObserver.observe(video); });
  }

  /* ---------- social-proof toast ---------- */
  var toastWrap = $('.proof-toasts');
  if (toastWrap) {
    var toastData = [];
    try { toastData = JSON.parse(toastWrap.dataset.toasts || '[]'); } catch (error) { toastData = []; }
    if (toastData.length) {
      var toastIndex = 0;
      var showToast = function () {
        var toast = document.createElement('div');
        toast.className = 'proof-toast';
        var dot = document.createElement('span');
        dot.className = 'toast-dot';
        var copy = document.createElement('div');
        copy.textContent = toastData[toastIndex];
        toast.appendChild(dot);
        toast.appendChild(copy);
        toastWrap.appendChild(toast);
        requestAnimationFrame(function () { toast.classList.add('show'); });
        window.setTimeout(function () {
          toast.classList.remove('show');
          window.setTimeout(function () { toast.remove(); }, 400);
        }, 4800);
        toastIndex = (toastIndex + 1) % toastData.length;
      };
      window.setTimeout(showToast, 5000);
      window.setInterval(showToast, 14000);
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      searchClose();
      menuClose();
      closeDrawer();
    }
  });
}());
